import { IAssetMapping } from '@contracts/products/actions/settings/asset-mapping';

export interface ITouchMapping {
  sourceTouchId: string;
  action: TouchMappingAction;
  destinationTouchId?: string;
  assetMap?: IAssetMapping[];
}

export enum TouchMappingAction {
  Map = 'Map',
  Drop = 'Drop',
}
